import React from 'react'
import * as Sentry from '@sentry/react'
import { Redirect, Switch } from 'react-router-dom'

import {
  routes,
  useUserSignedIn,
  DynamicLoadingPage,
  useUserProfile,
  useSignOut,
} from '@sketch/modules-common'

const VerifiedUsersRoute: React.FCC = ({ children }) => {
  const isSignedIn = useUserSignedIn()
  const { data, loading, error } = useUserProfile(false, {
    skip: !isSignedIn,
  })
  const signOut = useSignOut({
    revokeSessions: 'all',
    reason: 'Verified user route error',
  })

  const isUserVerified = data?.me.isVerified

  if (loading) {
    return <DynamicLoadingPage />
  }

  if (error) {
    Sentry.captureMessage(
      `VerifiedUsersRoute Signed Out: ${error.message}}`,
      scope => {
        scope.addBreadcrumb({
          category: 'Authentication',
          message: 'Signing the user out',
          level: 'error',
        })

        return scope
      }
    )

    signOut()
    window.location.reload()
    return <></>
  }

  /**
   * We are locking all users (signed in) that did not verify their email in the
   * "Check your inbox" page. Unverified users can no longer use the web app
   */
  if (isSignedIn && !isUserVerified) {
    return <Redirect to={routes.CHECK_YOUR_INBOX.create({})} />
  }

  /**
   * We added the Switch here to make sure only one of the children routes would render
   * In a particular scenario, multiple components were being rendered due the children Routes
   * not having a Switch parent component
   */
  return <Switch>{children}</Switch>
}

export default VerifiedUsersRoute
